<!-- <div class="full-screen-bg">
	<div class="container container-sm">
		<div class="row">
			<div class="col"></div>
			<div class="col-6 rounded my-5 form-bg">
				<div class="row">
					<div class="col text-center my-4">
						<img src="../assets/img/3Cube-White.png" alt="Image" width="130px" />
					</div>
				</div>
				<div class="row">
					<div class="col text-center">
						<h3 class="text-light mb-0">
							Task Management System
						</h3>
					</div>
				</div>
				<div class="row px-3">
					<div class="col">
						@if (is_mfa) {
						<form role="form" (ngSubmit)="verifyOTP()">
							<div class="row my-2">
								<div class="col">
									<div class="input-group mb-3">
										<span class="input-group-text">Code</span>
										<input type="text" class="form-control" placeholder="Enter Code"
											aria-label="otp" aria-describedby="basic-addon1" [(ngModel)]="auth.otp"
											[ngModelOptions]="{standalone: true}" required>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col">
									<button type="submit" class="btn btn-success w-100"
										[disabled]="loadershow || !auth.otp">
										@if (loadershow) {
										<fa-icon [icon]="['fas', 'spinner']" [animation]="'spin'" class="me-1">
										</fa-icon>
										}
										Verify
									</button>
								</div>
							</div>
						</form>
						}@else {
						<form role="form" (ngSubmit)="submitForm(user)">
							<div class="row mt-2">
								<div class="col">
									<div class="input-group mb-3">
										<span class="input-group-text">
											<fa-icon [icon]="['fas', 'user']"></fa-icon>
										</span>
										<input type="text" class="form-control" placeholder="Username"
											aria-label="Username" aria-describedby="basic-addon1"
											[(ngModel)]="user.username" [ngModelOptions]="{standalone: true}">
									</div>
								</div>
							</div>
							<div class="row mt-2">
								<div class="col">
									<div class="input-group mb-3">
										<span class="input-group-text">
											<fa-icon [icon]="['fas', 'lock']"></fa-icon>
										</span>
										<input type="password" class="form-control" placeholder="Password"
											aria-label="Password" aria-describedby="basic-addon1"
											[(ngModel)]="user.password" [ngModelOptions]="{standalone: true}">
									</div>
								</div>

							</div>
							<div class="row mt-2">
								<div class="col text-center">
									<button type="submit" class="btn btn-light w-100"
										[disabled]="loadershow || !user.username || !user.password">
										@if (loadershow) {
										<fa-icon [icon]="['fas', 'spinner']" [animation]="'spin'" class="me-1">
										</fa-icon>
										}
										Login
									</button>
								</div>
							</div>
						</form>
						}
					</div>
				</div>
				<div class="row mb-2">
					<div class="col-sm-12 text-center text-light fw-bold mt-1">
						&nbsp;&copy; {{year}}&nbsp;
						<a href="http://3cubeservices.com/" target="_blank" class="text-light">
							3CUBE
						</a>
					</div>
				</div>
				@if(loginErrorshow){
				<div class="row my-1">
					<div class="col">
						<div class="alert alert-danger text-center" role="alert">
							<label>{{loginFormErr}}</label>
						</div>
					</div>
				</div>
				}
			</div>
			<div class="col"></div>
		</div>
	</div>
</div> -->
<div class="full-screen-bg">
	<div class="container container-sm">
		<div class="row justify-content-center">
			<div class="col-11 col-sm-9 col-md-7 col-lg-5 rounded my-5 form-bg">
				<div class="row">
					<div class="col text-center mb-3">
						<img src="../assets/img/3Cube-White.png" alt="Image" width="120px" class="mb-2" />
						<h3 class="system-title mb-0">
							Task Management System
						</h3>
					</div>
				</div>
				<div class="row px-2">
					<div class="col">
						@if (is_mfa) {
						<form role="form" (ngSubmit)="verifyOTP()">
							<div class="row my-2">
								<div class="col">
									<div class="input-group custom-input-group mb-3">
										<span class="input-group-text">
											<fa-icon [icon]="['fas', 'shield-alt']"></fa-icon>
										</span>
										<input type="text" class="form-control" placeholder="Enter Code"
											aria-label="otp" aria-describedby="basic-addon1" [(ngModel)]="auth.otp"
											[ngModelOptions]="{standalone: true}" required>
									</div>
								</div>
							</div>
							<div class="row mt-3">
								<div class="col">
									<button type="submit" class="btn btn-bronze w-100"
										[disabled]="loadershow || !auth.otp">
										@if (loadershow) {
										<fa-icon [icon]="['fas', 'spinner']" [animation]="'spin'" class="me-1">
										</fa-icon>
										}
										Verify
									</button>
								</div>
							</div>
						</form>
						}@else {
						<form role="form" (ngSubmit)="submitForm(user)">
							<div class="row mt-2">
								<div class="col">
									<div class="input-group custom-input-group mb-3">
										<span class="input-group-text">
											<fa-icon [icon]="['fas', 'user']"></fa-icon>
										</span>
										<input type="text" class="form-control" placeholder="Username"
											aria-label="Username" aria-describedby="basic-addon1"
											[(ngModel)]="user.username" [ngModelOptions]="{standalone: true}">
									</div>
								</div>
							</div>
							<div class="row mt-2">
								<div class="col">
									<div class="input-group custom-input-group mb-3">
										<span class="input-group-text">
											<fa-icon [icon]="['fas', 'lock']"></fa-icon>
										</span>
										<input type="password" class="form-control" placeholder="Password"
											aria-label="Password" aria-describedby="basic-addon1"
											[(ngModel)]="user.password" [ngModelOptions]="{standalone: true}">
									</div>
								</div>
							</div>
							<div class="row mt-3">
								<div class="col text-center">
									<button type="submit" class="btn btn-bronze w-100"
										[disabled]="loadershow || !user.username || !user.password">
										@if (loadershow) {
										<fa-icon [icon]="['fas', 'spinner']" [animation]="'spin'" class="me-1">
										</fa-icon>
										}
										Login
									</button>
								</div>
							</div>
						</form>
						}
					</div>
				</div>
				@if (loginErrorshow) {
				<div class="row my-2">
					<div class="col">
						<div class="alert alert-danger text-center py-2 mb-0" role="alert">
							<small>{{loginFormErr}}</small>
						</div>
					</div>
				</div>
				}
				<div class="row mt-4 mb-2">
					<div class="col-sm-12 text-center text-light small fw-semibold">
						&copy; {{year}}&nbsp;
						<a href="http://3cubeservices.com/" target="_blank" class="text-light text-decoration-none">
							3CUBE
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>